import getWidgetByName from "../requests";
import { Articles } from "../../articles/entities";
import {prop, take} from "ramda";

const getLatestNewsWidget = () =>
  getWidgetByName("latestnewsasidewidget")
    .then(Articles)
    .then(prop("articles"))
    .then(take(5))

export { getLatestNewsWidget };
